import { ReactElement } from 'react';

import { ChevronRightIcon, StyledFlex } from '@dreryk/react-components';
import { dateTimeMinuteFormatter } from '@dreryk/react-common';

import { Notification } from '../ConfidentialityNotificationsIcon.hooks';

import { buildNotificationMessage, getNotificationResourceName } from './NotificationItem.utils';
import {
   StyledNotificationChevron,
   StyledNotificationDate,
   StyledNotificationItemContainer,
   StyledNotificationMessage,
   StyledNotificationResource,
   StyledNotificationUnreadDot,
} from './NotificationItem.styled';

type NotificationItemProps = {
   notification: Notification;
};

export const NotificationItem = ({ notification }: NotificationItemProps): ReactElement => {
   const resourceName = getNotificationResourceName(notification);

   return (
      <StyledNotificationItemContainer alignItems={'center'} gap={10} width={'100%'}>
         <StyledFlex direction={'column'} flex={'1'}>
            <StyledNotificationMessage>{buildNotificationMessage(notification)}</StyledNotificationMessage>
            {resourceName ? <StyledNotificationResource>{resourceName}</StyledNotificationResource> : null}
            <StyledNotificationDate dateTime={String(notification.createdAt)}>
               {dateTimeMinuteFormatter(notification.createdAt)}
            </StyledNotificationDate>
         </StyledFlex>
         {notification.read ? null : <StyledNotificationUnreadDot />}
         <StyledNotificationChevron>
            <ChevronRightIcon />
         </StyledNotificationChevron>
      </StyledNotificationItemContainer>
   );
};
